export const NAVER_LOGIN = {
    clientId: "j9_lXdV8eGCXbi0qsMDR",
    callbackUrl: "http://localhost:3000/login/loginCallback"
};

export const NAVER_LOGIN_PRODUCTION = {
    clientId: "Lzp6evOhcxz_uWDBxkTE",
    callbackUrl: "https://picnici.com/login/loginCallback"
};

export const DISTRICT_CODE = [{"code":0,"parent":"전국","name":"미확인","parentCode":0},{"code":11110,"parent":"서울특별시","name":"종로구","parentCode":11},{"code":11140,"parent":"서울특별시","name":"중구","parentCode":11},{"code":11170,"parent":"서울특별시","name":"용산구","parentCode":11},{"code":11200,"parent":"서울특별시","name":"성동구","parentCode":11},{"code":11215,"parent":"서울특별시","name":"광진구","parentCode":11},{"code":11230,"parent":"서울특별시","name":"동대문구","parentCode":11},{"code":11260,"parent":"서울특별시","name":"중랑구","parentCode":11},{"code":11290,"parent":"서울특별시","name":"성북구","parentCode":11},{"code":11305,"parent":"서울특별시","name":"강북구","parentCode":11},{"code":11320,"parent":"서울특별시","name":"도봉구","parentCode":11},{"code":11350,"parent":"서울특별시","name":"노원구","parentCode":11},{"code":11380,"parent":"서울특별시","name":"은평구","parentCode":11},{"code":11410,"parent":"서울특별시","name":"서대문구","parentCode":11},{"code":11440,"parent":"서울특별시","name":"마포구","parentCode":11},{"code":11470,"parent":"서울특별시","name":"양천구","parentCode":11},{"code":11500,"parent":"서울특별시","name":"강서구","parentCode":11},{"code":11530,"parent":"서울특별시","name":"구로구","parentCode":11},{"code":11545,"parent":"서울특별시","name":"금천구","parentCode":11},{"code":11560,"parent":"서울특별시","name":"영등포구","parentCode":11},{"code":11590,"parent":"서울특별시","name":"동작구","parentCode":11},{"code":11620,"parent":"서울특별시","name":"관악구","parentCode":11},{"code":11650,"parent":"서울특별시","name":"서초구","parentCode":11},{"code":11680,"parent":"서울특별시","name":"강남구","parentCode":11},{"code":11710,"parent":"서울특별시","name":"송파구","parentCode":11},{"code":11740,"parent":"서울특별시","name":"강동구","parentCode":11},{"code":26110,"parent":"부산광역시","name":"중구","parentCode":26},{"code":26140,"parent":"부산광역시","name":"서구","parentCode":26},{"code":26170,"parent":"부산광역시","name":"동구","parentCode":26},{"code":26200,"parent":"부산광역시","name":"영도구","parentCode":26},{"code":26230,"parent":"부산광역시","name":"부산진구","parentCode":26},{"code":26260,"parent":"부산광역시","name":"동래구","parentCode":26},{"code":26290,"parent":"부산광역시","name":"남구","parentCode":26},{"code":26320,"parent":"부산광역시","name":"북구","parentCode":26},{"code":26350,"parent":"부산광역시","name":"해운대구","parentCode":26},{"code":26380,"parent":"부산광역시","name":"사하구","parentCode":26},{"code":26410,"parent":"부산광역시","name":"금정구","parentCode":26},{"code":26440,"parent":"부산광역시","name":"강서구","parentCode":26},{"code":26470,"parent":"부산광역시","name":"연제구","parentCode":26},{"code":26500,"parent":"부산광역시","name":"수영구","parentCode":26},{"code":26530,"parent":"부산광역시","name":"사상구","parentCode":26},{"code":26710,"parent":"부산광역시","name":"기장군","parentCode":26},{"code":27110,"parent":"대구광역시","name":"중구","parentCode":27},{"code":27140,"parent":"대구광역시","name":"동구","parentCode":27},{"code":27170,"parent":"대구광역시","name":"서구","parentCode":27},{"code":27200,"parent":"대구광역시","name":"남구","parentCode":27},{"code":27230,"parent":"대구광역시","name":"북구","parentCode":27},{"code":27260,"parent":"대구광역시","name":"수성구","parentCode":27},{"code":27290,"parent":"대구광역시","name":"달서구","parentCode":27},{"code":27710,"parent":"대구광역시","name":"달성군","parentCode":27},{"code":28110,"parent":"인천광역시","name":"중구","parentCode":28},{"code":28140,"parent":"인천광역시","name":"동구","parentCode":28},{"code":28170,"parent":"인천광역시","name":"남구","parentCode":28},{"code":28185,"parent":"인천광역시","name":"연수구","parentCode":28},{"code":28200,"parent":"인천광역시","name":"남동구","parentCode":28},{"code":28237,"parent":"인천광역시","name":"부평구","parentCode":28},{"code":28245,"parent":"인천광역시","name":"계양구","parentCode":28},{"code":28260,"parent":"인천광역시","name":"서구","parentCode":28},{"code":28710,"parent":"인천광역시","name":"강화군","parentCode":28},{"code":28720,"parent":"인천광역시","name":"옹진군","parentCode":28},{"code":29110,"parent":"광주광역시","name":"동구","parentCode":29},{"code":29140,"parent":"광주광역시","name":"서구","parentCode":29},{"code":29155,"parent":"광주광역시","name":"남구","parentCode":29},{"code":29170,"parent":"광주광역시","name":"북구","parentCode":29},{"code":29200,"parent":"광주광역시","name":"광산구","parentCode":29},{"code":30110,"parent":"대전광역시","name":"동구","parentCode":30},{"code":30140,"parent":"대전광역시","name":"중구","parentCode":30},{"code":30170,"parent":"대전광역시","name":"서구","parentCode":30},{"code":30200,"parent":"대전광역시","name":"유성구","parentCode":30},{"code":30230,"parent":"대전광역시","name":"대덕구","parentCode":30},{"code":31110,"parent":"울산광역시","name":"중구","parentCode":31},{"code":31140,"parent":"울산광역시","name":"남구","parentCode":31},{"code":31170,"parent":"울산광역시","name":"동구","parentCode":31},{"code":31200,"parent":"울산광역시","name":"북구","parentCode":31},{"code":31710,"parent":"울산광역시","name":"울주군","parentCode":31},{"code":36110,"parent":"세종특별자치시","name":"세종특별자치시","parentCode":36},{"code":41110,"parent":"경기도","name":"수원시","parentCode":41},{"code":41130,"parent":"경기도","name":"성남시","parentCode":41},{"code":41150,"parent":"경기도","name":"의정부시","parentCode":41},{"code":41170,"parent":"경기도","name":"안양시","parentCode":41},{"code":41190,"parent":"경기도","name":"부천시","parentCode":41},{"code":41210,"parent":"경기도","name":"광명시","parentCode":41},{"code":41220,"parent":"경기도","name":"평택시","parentCode":41},{"code":41250,"parent":"경기도","name":"동두천시","parentCode":41},{"code":41270,"parent":"경기도","name":"안산시","parentCode":41},{"code":41280,"parent":"경기도","name":"고양시","parentCode":41},{"code":41290,"parent":"경기도","name":"과천시","parentCode":41},{"code":41310,"parent":"경기도","name":"구리시","parentCode":41},{"code":41360,"parent":"경기도","name":"남양주시","parentCode":41},{"code":41370,"parent":"경기도","name":"오산시","parentCode":41},{"code":41390,"parent":"경기도","name":"시흥시","parentCode":41},{"code":41410,"parent":"경기도","name":"군포시","parentCode":41},{"code":41430,"parent":"경기도","name":"의왕시","parentCode":41},{"code":41450,"parent":"경기도","name":"하남시","parentCode":41},{"code":41460,"parent":"경기도","name":"용인시","parentCode":41},{"code":41480,"parent":"경기도","name":"파주시","parentCode":41},{"code":41500,"parent":"경기도","name":"이천시","parentCode":41},{"code":41550,"parent":"경기도","name":"안성시","parentCode":41},{"code":41570,"parent":"경기도","name":"김포시","parentCode":41},{"code":41590,"parent":"경기도","name":"화성시","parentCode":41},{"code":41610,"parent":"경기도","name":"광주시","parentCode":41},{"code":41630,"parent":"경기도","name":"양주시","parentCode":41},{"code":41650,"parent":"경기도","name":"포천시","parentCode":41},{"code":41670,"parent":"경기도","name":"여주시","parentCode":41},{"code":41800,"parent":"경기도","name":"연천군","parentCode":41},{"code":41820,"parent":"경기도","name":"가평군","parentCode":41},{"code":41830,"parent":"경기도","name":"양평군","parentCode":41},{"code":42110,"parent":"강원도","name":"춘천시","parentCode":42},{"code":42130,"parent":"강원도","name":"원주시","parentCode":42},{"code":42150,"parent":"강원도","name":"강릉시","parentCode":42},{"code":42170,"parent":"강원도","name":"동해시","parentCode":42},{"code":42190,"parent":"강원도","name":"태백시","parentCode":42},{"code":42210,"parent":"강원도","name":"속초시","parentCode":42},{"code":42230,"parent":"강원도","name":"삼척시","parentCode":42},{"code":42720,"parent":"강원도","name":"홍천군","parentCode":42},{"code":42730,"parent":"강원도","name":"횡성군","parentCode":42},{"code":42750,"parent":"강원도","name":"영월군","parentCode":42},{"code":42760,"parent":"강원도","name":"평창군","parentCode":42},{"code":42770,"parent":"강원도","name":"정선군","parentCode":42},{"code":42780,"parent":"강원도","name":"철원군","parentCode":42},{"code":42790,"parent":"강원도","name":"화천군","parentCode":42},{"code":42800,"parent":"강원도","name":"양구군","parentCode":42},{"code":42810,"parent":"강원도","name":"인제군","parentCode":42},{"code":42820,"parent":"강원도","name":"고성군","parentCode":42},{"code":42830,"parent":"강원도","name":"양양군","parentCode":42},{"code":43110,"parent":"충청북도","name":"청주시","parentCode":43},{"code":43130,"parent":"충청북도","name":"충주시","parentCode":43},{"code":43150,"parent":"충청북도","name":"제천시","parentCode":43},{"code":43720,"parent":"충청북도","name":"보은군","parentCode":43},{"code":43730,"parent":"충청북도","name":"옥천군","parentCode":43},{"code":43740,"parent":"충청북도","name":"영동군","parentCode":43},{"code":43745,"parent":"충청북도","name":"증평군","parentCode":43},{"code":43750,"parent":"충청북도","name":"진천군","parentCode":43},{"code":43760,"parent":"충청북도","name":"괴산군","parentCode":43},{"code":43770,"parent":"충청북도","name":"음성군","parentCode":43},{"code":43800,"parent":"충청북도","name":"단양군","parentCode":43},{"code":44130,"parent":"충청남도","name":"천안시","parentCode":44},{"code":44150,"parent":"충청남도","name":"공주시","parentCode":44},{"code":44180,"parent":"충청남도","name":"보령시","parentCode":44},{"code":44200,"parent":"충청남도","name":"아산시","parentCode":44},{"code":44210,"parent":"충청남도","name":"서산시","parentCode":44},{"code":44230,"parent":"충청남도","name":"논산시","parentCode":44},{"code":44250,"parent":"충청남도","name":"계룡시","parentCode":44},{"code":44710,"parent":"충청남도","name":"금산군","parentCode":44},{"code":44270,"parent":"충청남도","name":"당진시","parentCode":44},{"code":44760,"parent":"충청남도","name":"부여군","parentCode":44},{"code":44770,"parent":"충청남도","name":"서천군","parentCode":44},{"code":44790,"parent":"충청남도","name":"청양군","parentCode":44},{"code":44800,"parent":"충청남도","name":"홍성군","parentCode":44},{"code":44810,"parent":"충청남도","name":"예산군","parentCode":44},{"code":44825,"parent":"충청남도","name":"태안군","parentCode":44},{"code":45110,"parent":"전라북도","name":"전주시","parentCode":45},{"code":45130,"parent":"전라북도","name":"군산시","parentCode":45},{"code":45140,"parent":"전라북도","name":"익산시","parentCode":45},{"code":45180,"parent":"전라북도","name":"정읍시","parentCode":45},{"code":45190,"parent":"전라북도","name":"남원시","parentCode":45},{"code":45210,"parent":"전라북도","name":"김제시","parentCode":45},{"code":45710,"parent":"전라북도","name":"완주군","parentCode":45},{"code":45720,"parent":"전라북도","name":"진안군","parentCode":45},{"code":45730,"parent":"전라북도","name":"무주군","parentCode":45},{"code":45740,"parent":"전라북도","name":"장수군","parentCode":45},{"code":45750,"parent":"전라북도","name":"임실군","parentCode":45},{"code":45770,"parent":"전라북도","name":"순창군","parentCode":45},{"code":45790,"parent":"전라북도","name":"고창군","parentCode":45},{"code":45800,"parent":"전라북도","name":"부안군","parentCode":45},{"code":46110,"parent":"전라남도","name":"목포시","parentCode":46},{"code":46130,"parent":"전라남도","name":"여수시","parentCode":46},{"code":46150,"parent":"전라남도","name":"순천시","parentCode":46},{"code":46170,"parent":"전라남도","name":"나주시","parentCode":46},{"code":46230,"parent":"전라남도","name":"광양시","parentCode":46},{"code":46710,"parent":"전라남도","name":"담양군","parentCode":46},{"code":46720,"parent":"전라남도","name":"곡성군","parentCode":46},{"code":46730,"parent":"전라남도","name":"구례군","parentCode":46},{"code":46770,"parent":"전라남도","name":"고흥군","parentCode":46},{"code":46780,"parent":"전라남도","name":"보성군","parentCode":46},{"code":46790,"parent":"전라남도","name":"화순군","parentCode":46},{"code":46800,"parent":"전라남도","name":"장흥군","parentCode":46},{"code":46810,"parent":"전라남도","name":"강진군","parentCode":46},{"code":46820,"parent":"전라남도","name":"해남군","parentCode":46},{"code":46830,"parent":"전라남도","name":"영암군","parentCode":46},{"code":46840,"parent":"전라남도","name":"무안군","parentCode":46},{"code":46860,"parent":"전라남도","name":"함평군","parentCode":46},{"code":46870,"parent":"전라남도","name":"영광군","parentCode":46},{"code":46880,"parent":"전라남도","name":"장성군","parentCode":46},{"code":46890,"parent":"전라남도","name":"완도군","parentCode":46},{"code":46900,"parent":"전라남도","name":"진도군","parentCode":46},{"code":46910,"parent":"전라남도","name":"신안군","parentCode":46},{"code":47110,"parent":"경상북도","name":"포항시","parentCode":47},{"code":47130,"parent":"경상북도","name":"경주시","parentCode":47},{"code":47150,"parent":"경상북도","name":"김천시","parentCode":47},{"code":47170,"parent":"경상북도","name":"안동시","parentCode":47},{"code":47190,"parent":"경상북도","name":"구미시","parentCode":47},{"code":47210,"parent":"경상북도","name":"영주시","parentCode":47},{"code":47230,"parent":"경상북도","name":"영천시","parentCode":47},{"code":47250,"parent":"경상북도","name":"상주시","parentCode":47},{"code":47280,"parent":"경상북도","name":"문경시","parentCode":47},{"code":47290,"parent":"경상북도","name":"경산시","parentCode":47},{"code":47720,"parent":"경상북도","name":"군위군","parentCode":47},{"code":47730,"parent":"경상북도","name":"의성군","parentCode":47},{"code":47750,"parent":"경상북도","name":"청송군","parentCode":47},{"code":47760,"parent":"경상북도","name":"영양군","parentCode":47},{"code":47770,"parent":"경상북도","name":"영덕군","parentCode":47},{"code":47820,"parent":"경상북도","name":"청도군","parentCode":47},{"code":47830,"parent":"경상북도","name":"고령군","parentCode":47},{"code":47840,"parent":"경상북도","name":"성주군","parentCode":47},{"code":47850,"parent":"경상북도","name":"칠곡군","parentCode":47},{"code":47900,"parent":"경상북도","name":"예천군","parentCode":47},{"code":47920,"parent":"경상북도","name":"봉화군","parentCode":47},{"code":47930,"parent":"경상북도","name":"울진군","parentCode":47},{"code":47940,"parent":"경상북도","name":"울릉군","parentCode":47},{"code":48120,"parent":"경상남도","name":"창원시","parentCode":48},{"code":48170,"parent":"경상남도","name":"진주시","parentCode":48},{"code":48220,"parent":"경상남도","name":"통영시","parentCode":48},{"code":48240,"parent":"경상남도","name":"사천시","parentCode":48},{"code":48250,"parent":"경상남도","name":"김해시","parentCode":48},{"code":48270,"parent":"경상남도","name":"밀양시","parentCode":48},{"code":48310,"parent":"경상남도","name":"거제시","parentCode":48},{"code":48330,"parent":"경상남도","name":"양산시","parentCode":48},{"code":48720,"parent":"경상남도","name":"의령군","parentCode":48},{"code":48730,"parent":"경상남도","name":"함안군","parentCode":48},{"code":48740,"parent":"경상남도","name":"창녕군","parentCode":48},{"code":48820,"parent":"경상남도","name":"고성군","parentCode":48},{"code":48840,"parent":"경상남도","name":"남해군","parentCode":48},{"code":48850,"parent":"경상남도","name":"하동군","parentCode":48},{"code":48860,"parent":"경상남도","name":"산청군","parentCode":48},{"code":48870,"parent":"경상남도","name":"함양군","parentCode":48},{"code":48880,"parent":"경상남도","name":"거창군","parentCode":48},{"code":48890,"parent":"경상남도","name":"합천군","parentCode":48},{"code":50110,"parent":"제주특별자치도","name":"제주시","parentCode":50},{"code":50130,"parent":"제주특별자치도","name":"서귀포시","parentCode":50}];

export const SVG_MARKER_ICON = {
    eating: '<svg aria-hidden="true" width="10px" height="10px" data-prefix="fas" data-icon="utensils" class="svg-inline--fa fa-utensils fa-w-13" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 416 512"><path fill="currentColor" d="M207.9 15.2c.8 4.7 16.1 94.5 16.1 128.8 0 52.3-27.8 89.6-68.9 104.6L168 486.7c.7 13.7-10.2 25.3-24 25.3H80c-13.7 0-24.7-11.5-24-25.3l12.9-238.1C27.7 233.6 0 196.2 0 144 0 109.6 15.3 19.9 16.1 15.2 19.3-5.1 61.4-5.4 64 16.3v141.2c1.3 3.4 15.1 3.2 16 0 1.4-25.3 7.9-139.2 8-141.8 3.3-20.8 44.7-20.8 47.9 0 .2 2.7 6.6 116.5 8 141.8.9 3.2 14.8 3.4 16 0V16.3c2.6-21.6 44.8-21.4 48-1.1zm119.2 285.7l-15 185.1c-1.2 14 9.9 26 23.9 26h56c13.3 0 24-10.7 24-24V24c0-13.2-10.7-24-24-24-82.5 0-221.4 178.5-64.9 300.9z"></path></svg>',
    playing: '<svg aria-hidden="true" width="10px" height="10px" data-prefix="fas" data-icon="bowling-ball" class="svg-inline--fa fa-bowling-ball fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 496 512"><path fill="currentColor" d="M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM120 192c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm64-96c0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32-32-14.3-32-32zm48 144c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"></path></svg>',
    accommodation: '<svg aria-hidden="true" width="10px" height="10px" data-prefix="fas" data-icon="bed" class="svg-inline--fa fa-bed fa-w-20" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><path fill="currentColor" d="M176 256c44.11 0 80-35.89 80-80s-35.89-80-80-80-80 35.89-80 80 35.89 80 80 80zm352-128H304c-8.84 0-16 7.16-16 16v144H64V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v352c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-48h512v48c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V240c0-61.86-50.14-112-112-112z"></path></svg>',
    marked: '<svg aria-hidden="true" width="10px" height="10px" data-prefix="fas" data-icon="map-marked" class="svg-inline--fa fa-map-marked fa-w-18" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path fill="currentColor" d="M288 0c-69.59 0-126 56.41-126 126 0 56.26 82.35 158.8 113.9 196.02 6.39 7.54 17.82 7.54 24.2 0C331.65 284.8 414 182.26 414 126 414 56.41 357.59 0 288 0zM20.12 215.95A32.006 32.006 0 0 0 0 245.66v250.32c0 11.32 11.43 19.06 21.94 14.86L160 448V214.92c-8.84-15.98-16.07-31.54-21.25-46.42L20.12 215.95zM288 359.67c-14.07 0-27.38-6.18-36.51-16.96-19.66-23.2-40.57-49.62-59.49-76.72v182l192 64V266c-18.92 27.09-39.82 53.52-59.49 76.72-9.13 10.77-22.44 16.95-36.51 16.95zm266.06-198.51L416 224v288l139.88-55.95A31.996 31.996 0 0 0 576 426.34V176.02c0-11.32-11.43-19.06-21.94-14.86z"></path></svg>'
};

export const DEFAULT_GPS_LOCATION = {lat: 37.554690, lng: 126.970702};

export const GEO_LOCATION = {
    TO_RADIAN: 0.0174532925,
    TO_DEGREE: 57.2957795,
    EARTH_RADIUS: 6371.01,
    TO_MILE: 0.621371192,
    TO_KM: 1.609344,
    MIN_LAT() { return GEO_LOCATION.degreeToRadian(-90) },
    MAX_LAT() { return GEO_LOCATION.degreeToRadian(90) },
    MIN_LON() { return GEO_LOCATION.degreeToRadian(-180) },
    MAX_LON() { return GEO_LOCATION.degreeToRadian(180) },

    degreeToRadian(degree) { return degree * GEO_LOCATION.TO_RADIAN },
    radianToDegree(radian) { return radian * GEO_LOCATION.TO_DEGREE },
    kmToMile(km) {return km * GEO_LOCATION.TO_MILE },
    mileToKm(mile) {return mile * GEO_LOCATION.TO_KM },

    buildLocationRange(latitude, longitude, boundaryInKilometers) {
        const degLat = latitude;
        const degLon = longitude;
        const radLat = GEO_LOCATION.degreeToRadian(degLat);
        const radLon = GEO_LOCATION.degreeToRadian(degLon);

        const location = {  degLat: degLat
            , degLon: degLon
            , radLat: radLat
            , radLon: radLon
        };

        GEO_LOCATION.checkBounds(location);
        const locationRange = GEO_LOCATION.boundingCoordinates(location, boundaryInKilometers);

        return locationRange;
    },

    checkBounds(location) {
        if (location.radLat < GEO_LOCATION.MIN_LAT || location.radLat > GEO_LOCATION.MAX_LAT ||
            location.radLon < GEO_LOCATION.MIN_LON || location.radLon > GEO_LOCATION.MAX_LON) {
            //console.log("radLat or radLon is out of bounds");
        }
    },

    distance(location1, location2) {
        return Math.acos(Math.sin(location1.radLat) * Math.sin(location2.radLat) +
            Math.cos(location1.radLat) * Math.cos(location2.radLat) *
            Math.cos(location1.radLon - location2.radLon)) * GEO_LOCATION.EARTH_RADIUS;
    },

    getDistance(location1, location2) {
        const dLat = GEO_LOCATION.degreeToRadian(location2.latitude - location1.latitude);
        const dLon = GEO_LOCATION.degreeToRadian(location2.longitude - location1.longitude);
        const lat1 = GEO_LOCATION.degreeToRadian(location1.latitude);
        const lat2 = GEO_LOCATION.degreeToRadian(location2.latitude);

        const a = Math.sin(dLat/2) * Math.sin(dLat/2) +
            Math.sin(dLon/2) * Math.sin(dLon/2) * Math.cos(lat1) * Math.cos(lat2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
        const d = GEO_LOCATION.EARTH_RADIUS * c;
        return d;
    },

    boundingCoordinates(location, distance) {
        if (!location || distance < 0) {
            //console.log("no location or distance");
            return;
        }

        const radius = GEO_LOCATION.EARTH_RADIUS;
        const radDist = distance / radius;
        let minLat = location.radLat - radDist;
        let maxLat = location.radLat + radDist;

        let minLon, maxLon;

        if (minLat > GEO_LOCATION.MIN_LAT() && maxLat < GEO_LOCATION.MAX_LAT()) {
            const deltaLon = Math.asin(Math.sin(radDist) / Math.cos(location.radLat));
            minLon = location.radLon - deltaLon;
            if (minLon < GEO_LOCATION.MIN_LON()) minLon += 2 * Math.PI;
            maxLon = location.radLon + deltaLon;
            if (maxLon > GEO_LOCATION.MAX_LON()) maxLon -= 2 * Math.PI;
        } else {
            // a pole is within the distance
            minLat = Math.max(minLat, GEO_LOCATION.MIN_LAT());
            maxLat = Math.min(maxLat, GEO_LOCATION.MAX_LAT());
            minLon = GEO_LOCATION.MIN_LON();
            maxLon = GEO_LOCATION.MAX_LON();
        }

        const locationRange = {  lat: location.degLat
            , lon: location.degLon
            , minLat: GEO_LOCATION.radianToDegree(minLat)
            , maxLat: GEO_LOCATION.radianToDegree(maxLat)
            , minLon: GEO_LOCATION.radianToDegree(minLon)
            , maxLon: GEO_LOCATION.radianToDegree(maxLon)
        };
        return locationRange;
    }
};

export function GET_JOSA(word, type) {
    let josa = type;
    try {
        const code = word.charCodeAt(word.length-1) - 44032;
        if (word.length !== 0 && code >= 0 &&  code <= 11171){
            if (code % 28 === 0){
                switch (type){
                    case '을': josa = '를'; break;
                    case '이': josa = '가'; break;
                    case '은': josa = '는'; break;
                    case '과': josa = '와'; break;
                    default:
                        console.error('NO TARGET');
                }
            }
        }
    } catch (e) {
        josa = type;
    }
    return josa;
}

export function ENCODE_QUERY_DATA(data) {
    const ret = [];
    for (let d in data){
        ret.push(encodeURI(d) + '=' + encodeURI(data[d]));
    }
    return ret.join('&');
}

export function CHECK_ANONYMOUS(props, showMessage){
    if(props.userInfo.isAnonymous && showMessage) props.showToastMessage('익명 로그인 상태에서는 사용이 제한됩니다.');
    return props.userInfo.isAnonymous
}

export function PROCESS_TO_CREATE_SCHEDULE_DATA(_, sl) {
    let data = {};
    let schedule = {};
    let scheduleOrder =  _.pluck(sl, 'id');

    for(let i = 0; i < sl.length; i ++){
        let es = sl[i];
        let s = {};
        s.id = es.id;
        s.name = es.name;
        s.desc = es.desc ? es.desc : '';
        s.userComment = es.userComment ? es.userComment : '';
        s.options = es.options ? es.options : '';
        s.tags = es.tags ? es.tags : [];
        s.type = es.type;
        s.category = es.category;
        s.imageSrc = es.imageSrc ? es.imageSrc : '';
        s.x = es.x;
        s.y = es.y;
        if(es.address){
            s.address = es.address;
        }else{
            if(es.roadAddr){
                s.address = es.roadAddr;
            }else{
                if(es.commonAddr){
                    if(es.addr){
                        s.address = es.commonAddr + ' ' + es.addr;
                    }else{
                        s.address = es.commonAddr;
                    }
                }else{
                    if(es.addr){
                        s.address = es.addr;
                    }else{
                        s.address = '';
                    }
                }
            }
        }

        let confirmedAdministrativeDistrict = false;
        for(let j = 0; j < DISTRICT_CODE.length; j ++){
            if(!confirmedAdministrativeDistrict){
                if(s.address.indexOf(DISTRICT_CODE[j].name) !== -1){
                    s.administrativeDistrict = DISTRICT_CODE[j];
                    try {
                        if(s.address.indexOf(DISTRICT_CODE[j].parent.substring(0,2)) !== -1){
                            confirmedAdministrativeDistrict = true;
                        }
                    } catch (e) {}
                }
            }
        }

        if(Object.keys(s.administrativeDistrict) === 0){
            s.administrativeDistrict = {"code":0,"parent":"전국","name":"미확인","parentCode":0};
        }
        schedule[s.id] = s;
    }

    let msdCount = 0, mostSelectedDistrict = 0, mspCount = 0, mostSelectedParent = 0;
    let representativeDistrict = {code: 0, name: "미확인"};
    let representativeParent = {parentCode: 0, parent: "전국"};
    let scheduleArray = Object.values(schedule);

    try {
        const msd = _.countBy(scheduleArray, (e) => {
            return e.administrativeDistrict.code
        });
        for(let key in msd){
            if(msd.hasOwnProperty(key)) {
                if(msd[key] > msdCount){
                    mostSelectedDistrict = parseInt(key);
                    msdCount = msd[key];
                }
            }
        }
        const rd = _.findWhere(DISTRICT_CODE, {code: mostSelectedDistrict});
        representativeDistrict = {code: rd.code, name: rd.name};

        const msp = _.countBy(scheduleArray, (e) => {
            return e.administrativeDistrict.parentCode
        });
        for(let key in msp){
            if(msp.hasOwnProperty(key)) {
                if(msp[key] > mspCount){
                    mostSelectedParent = parseInt(key);
                    mspCount = msp[key];
                }
            }
        };

        const rp = _.findWhere(DISTRICT_CODE, {parentCode: mostSelectedParent});
        representativeParent = {parentCode: rp.parentCode, parent: rp.parent};

        data.schedule = schedule;
        data.scheduleOrder = scheduleOrder;
        data.representative = {district: representativeDistrict, parent: representativeParent};
    } catch (e) {
        data = null;
        console.error(e);
    }
    return data;
}

export function CHECK_FINE_DUST_LEVEL(pm10, pm25) {
    const levelNameArray = {1: "좋음", 2: "양호", 3: "보통", 4: "나쁨", 5: "매우 나쁨"};
    let pm10Level = 1;
    let pm25Level = 1;
    const pm10LevelArray = [30, 50, 80, 150];
    const pm25LevelArray = [15, 25, 35, 75] ;

    for(let i = 0; i < pm10LevelArray.length; i ++){
        if(pm10LevelArray[i] < pm10){
            pm10Level = i + 2;
        }
    }

    for(let i = 0; i < pm25LevelArray.length; i ++){
        if(pm25LevelArray[i] < pm25){
            pm25Level = i + 2;
        }
    }

    const level = pm10Level > pm25Level ? pm10Level : pm25Level;
    return {level: level, name: levelNameArray[level]}
};

export function CHECK_WEATHER_LEVEL(SKY, PTY) {
    let name = "";
    let image = "";

    if(PTY === 0){
        if(SKY === 1){
            name = "맑음";
            image = "sunny";
        }else if(SKY === 2){
            name = "구름조금";
            image = "cloudy";
        }else if(SKY === 3){
            name = "구름많음";
            image = "cloud";
        }else if(SKY === 4){
            name = "흐림";
            image = "cloud";
        }
    }else if(PTY === 1){
        name = "비";
        image = "rainy";
    }else if(PTY === 2 || PTY === 3){
        name = "눈";
        image = "snow";
    }else {
        name = "눈";
        image = "snow";
    }

    return {image: image, name: name}
};

export function CHECK_TIME(i) {
    return (i < 10) ? "0" + i : i;
}

export function OPEN_EXTERNAL_LINK(url) {
    if(window.isRNWebView === true || window.isRNWebView === 'true'){
        const message = JSON.stringify({'type': 'OPEN_EXTERNAL_LINK', 'url': url});
        window.postMessage(message, "*");
    }else{
        const win = window.open(url, '_blank');
        win.focus();
    }
}

export function COPY_TO_CLIPBOARD(targetId, name, props) {
    let copyText = document.getElementById(targetId);

    let textArea = document.createElement("textarea");
    textArea.value = copyText.textContent;
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand("Copy");
    textArea.remove();

    props.showToastMessage(name + GET_JOSA(name, '이') + ' 복사되었습니다.')
}

export function NAVER_THUMBNAIL_GETTER(e){
    let src = "";
    if(e.imageSrc !== ''){
        src = ['https://search.pstatic.net/common/?autoRotate=true&quality=95&src=', e.imageSrc, '&type=b360'].join('')
    }else{
        src = 'https://simg.pstatic.net/static.map/image?version=1.1&crs=EPSG:4326&dataversion=198.2&caller=naver_mstore&baselayer=bl_vc_bg&overlayers=ol_vc_an&exception=xml&scale=5&level=9&center=' +
            e.x +
            ',' +
            e.y +
            '&markers_icon=type,ms_attr,' +
            e.x +
            ',' +
            e.y +
            '&w=140&h=140'
    }
    return src
}

export function GET_HEIGHT_FOR_NAVER_MAP(height){
    /*let heightPixel  = "";
    if(window.innerHeight > 768){
        heightPixel  = Number(height + 100) + 'px';
    }else{
        heightPixel  = height + 'px';
    }*/

    let heightPixel  = height + 'px';
    return heightPixel
}

export const SCHEDULE_SORT_KEY_TO_NAME = {
    date: '만남',
    picnic: '소풍',
    sightseeing: '관광',
    shopping: '쇼핑',
    eating: '먹자',
    history: '역사',
    study: '학습',
    healing: '힐링',
    activity: '활동',
    sport: '운동',
    outside: '실외',
    inside: '실내',
};

export const SCHEDULE_SORT_KEY_TO_COLOR = {
    /*date: '#e91e63',
    picnic: '#ffeb3b',
    sightseeing: '#8bc34a',
    shopping: '#673ab7',
    eating: '#f44336',
    history: '#9e9e9e',
    study: '#4caf50',
    healing: '#2196f3',
    activity: '#ff9800',
    sport: '#ff5722',
    outside: '#00bcd4',
    inside: '#607d8b',*/
    date: '#000000',
    picnic: '#000000',
    sightseeing: '#000000',
    shopping: '#000000',
    eating: '#000000',
    history: '#000000',
    study: '#000000',
    healing: '#000000',
    activity: '#000000',
    sport: '#000000',
    outside: '#000000',
    inside: '#000000',
};
